import { css } from "@compiled/react";

import { AgileVideo } from "@/components/agile-video/agile-video";
import { Image } from "@/content/templates/template.types";
import { RichContent } from "@/templates/agile-hub/src/components/rich-content/src/rich-content";
import { BodyAssetComponent } from "@/templates/agile-hub/src/sections/components/body-asset";
import { RichTextComponent } from "@/templates/agile-hub/src/sections/components/body-text";
import { ContentComponent } from "@/templates/agile-hub/types";

export interface AgileIntroductionProps {
    heading?: string | null;
    description?: string | null;
    image?: Image | null;
    embedLink?: string | null;
    body?: ContentComponent[] | null;
}

const headingStyle = css({
    marginBlockStart: 0
});

const contentWrapperCss = css({ marginBlockEnd: "20px" });

export const AgileIntroduction = ({
    heading,
    description,
    image,
    embedLink,
    body
}: AgileIntroductionProps) => {
    return (
        <>
            {heading && <h2 css={headingStyle}>{heading}</h2>}
            {description && (
                <div css={contentWrapperCss}>
                    <RichTextComponent text={description} name={null} />
                </div>
            )}
            {embedLink && (
                <div css={contentWrapperCss}>
                    <AgileVideo
                        embedLink={embedLink}
                        title={image?.description ?? ""}
                        thumbnail={image ?? null}
                    />
                </div>
            )}
            {image && !embedLink && (
                <div css={contentWrapperCss}>
                    <BodyAssetComponent asset={image} />
                </div>
            )}
            {body?.map((component, idx) => (
                <div key={idx} css={contentWrapperCss}>
                    <RichContent {...component} />
                </div>
            ))}
        </>
    );
};
